import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const resumeChatAction = createAsyncAction(
  '@chat/RESUME_CHAT_REQUEST',
  '@chat/RESUME_CHAT_SUCCESS',
  '@chat/RESUME_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingResumeChat: true
})

const success = (state: ChatState, action: ActionType<typeof resumeChatAction.success>): ChatState => {
  const { updatedChatData } = action.payload

  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnResumeChat: true,
    isLoadingResumeChat: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingResumeChat: false,
  isErrorOnResumeChat: true
})

export const resumeChatHandle = { asyncAction: resumeChatAction, request, success, failure }
